export class User {
    contact: string;
    lastName: string;
    email: string;
    mobile: string;
    userType: string;
    roles: Roles[];
}

export class Roles{
  id: number;
  roleName: string;
  roleDescription: string;
  roleId: number;
  userId: number;
}

export class UserCount{
  client: number;
  superAdmin: number;
  admin: number;
  serviceManager: number;
  safetyManager: number;
  operator: number;
  serviceTechnicians: number;
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/entities/User.ts